
export default {
  props: {
    currentStep: {
      type: Number,
      default: 0
    },
    steps: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  watch: {
    currentStep(val) {
      this.scrollToActiveStep();
    }
  },
  methods: {
    isCompletedStep(index) {
      return index < this.currentStep;
    },
    goTo(index) {
      if (this.isCompletedStep(index)) {
        this.$emit("goToStep", index);
      }
    },
    scrollToActiveStep() {
      this.$nextTick(() => {
        const activeStepElement = this.$refs.stepElement[this.currentStep + 1];
        if (activeStepElement) {
          activeStepElement.scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest"
          });
        }
      });
    }
  }
};
